import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import { createHead } from '@vueuse/head';
import { createMetaManager } from 'vue-meta';
import './assets/tailwind.css'; // Import Tailwind CSS

const app = createApp(App);
const head = createHead();

app.use(router); // Router musi być podłączony do aplikacji
app.use(createMetaManager()); // <-- kluczowy krok

app.use(head);
app.mount('#app');
